// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as React from "react";
import * as StringCodec from "./StringCodec.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as RescriptReactRouter from "@rescript/react/lib/es6/src/RescriptReactRouter.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function openBlankWindow(url) {
  window.open(url, "_blank");
}

function shouldOpenInTab(prim) {
  return prim.ctrlKey;
}

let ParseUrlError = /* @__PURE__ */Primitive_exceptions.create("LumiRoute.ParseUrlError");

function parseUrl(url, $$default, jsonCodec) {
  if (url.length === 0) {
    if ($$default !== undefined) {
      return Primitive_option.valFromOption($$default);
    }
    throw {
      RE_EXN_ID: ParseUrlError,
      _1: "EmptyUrl",
      Error: new Error()
    };
  }
  let res = Jzon.decodeStringWith(decodeURIComponent(url), jsonCodec);
  if (res.TAG === "Ok") {
    return res._0;
  }
  let err = res._0;
  console.error("Route decode error", err, url);
  if ($$default !== undefined) {
    return Primitive_option.valFromOption($$default);
  }
  throw {
    RE_EXN_ID: ParseUrlError,
    _1: {
      TAG: "DecodingError",
      _0: err
    },
    Error: new Error()
  };
}

function followUrl(url, newTabOpt) {
  let newTab = newTabOpt !== undefined ? newTabOpt : false;
  if (newTab) {
    return openBlankWindow(url);
  } else {
    return RescriptReactRouter.push(url);
  }
}

function followUrlOnClick(url) {
  return event => followUrl(url, event.ctrlKey);
}

function Make(Route) {
  let jsonCodec = Route.jsonCodec;
  let stringCodec = StringCodec.jzon(jsonCodec);
  let toString = stringCodec.toString;
  let parseUrl$1 = url => parseUrl(url, Route.$$default, jsonCodec);
  let useRoute = () => {
    let match = RescriptReactRouter.useUrl(undefined, undefined);
    let hash = match.hash;
    let route = React.useMemo(() => parseUrl(hash, Route.$$default, jsonCodec), [hash]);
    let toUrl = route => "#" + toString(route);
    return [
      route,
      toUrl
    ];
  };
  return {
    jsonCodec: jsonCodec,
    stringCodec: stringCodec,
    toString: toString,
    fromString: stringCodec.fromString,
    parseUrl: parseUrl$1,
    useRoute: useRoute
  };
}

export {
  openBlankWindow,
  shouldOpenInTab,
  ParseUrlError,
  parseUrl,
  followUrl,
  followUrlOnClick,
  Make,
}
/* react Not a pure module */
